import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import PasswordForm from 'pages/Security/PasswordForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { updateProfilePassword } from 'store/actions/users/updateProfile';

class SecurityContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            form,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                callback: (error) => {
                    if (error) {
                        // This location should have where we bounce the error back to the form with SubmissionError.
                        resolve();
                    }

                    resolve(reset(form));
                },
                formValues: values,
            });
        });
    }

    render() {
        const {
            form,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.profile.name'),
                link: '/profile',
            },
            {
                label: translate('resources.password.name'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.password.name') } />
                </Header>

                <Card>
                    <CardText>
                        <PasswordForm
                            form={ form }
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

SecurityContainer.defaultProps = {
    form: 'password_edit',
};

SecurityContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    form: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProfilePassword(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(SecurityContainer);



// WEBPACK FOOTER //
// ./src/pages/Security/SecurityContainer.js